import { useState } from 'react';

const allTestimonials = [
  {
    name: 'L.M.',
    stars: 5,
    text: 'Dave and Tayvn were absolutely wonderful throughout the entire process. They kept me informed, guided me in the right path and were always there to answer my questions. If you need someone to take pride in taking care of you in your case, choose them.',
    type: 'Criminal Defense',
    initials: 'LM',
  },
  {
    name: 'T.M.',
    stars: 5,
    text: "I wish I could give 10 stars. Dave really fights for you — you don't get that often where an attorney truly cares about you and your family. FULL CUSTODY for the dad!! Professional, quick to respond, and truly fights for results. They have become family.",
    type: 'Family Law',
    initials: 'TM',
  },
  {
    name: 'B.H.',
    stars: 5,
    text: "Mr. Bunger is the absolute best! He was very patient with us and did not pressure us in any way even though we took over a year to figure everything out. Don't waste your time anywhere else. Genuinely the best attorney in the area.",
    type: 'Estate Planning',
    initials: 'BH',
  },
  {
    name: 'R.S.',
    stars: 5,
    text: 'Highly responsive and got my charges reduced significantly. Dave took the time to explain every step and never made me feel rushed. His knowledge of the local courts made a real difference. Cannot recommend him highly enough.',
    type: 'Criminal Defense',
    initials: 'RS',
  },
  {
    name: 'C.T.',
    stars: 5,
    text: 'Professional, strategic, and results-driven. Made a very stressful situation completely manageable. Dave and his team were always available and kept me in the loop every step of the way. True advocate.',
    type: 'Criminal Defense',
    initials: 'CT',
  },
];

export default function SectionTestimonials() {
  const [active, setActive] = useState(1);

  const prev = () => setActive((a) => (a - 1 + allTestimonials.length) % allTestimonials.length);
  const next = () => setActive((a) => (a + 1) % allTestimonials.length);

  const getVisible = () => {
    const len = allTestimonials.length;
    return [
      (active - 1 + len) % len,
      active,
      (active + 1) % len,
    ];
  };

  const [left, center, right] = getVisible();

  return (
    <section className="bg-[#050a12] py-24 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.025]" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)', backgroundSize: '28px 28px' }} />
      <div className="absolute top-0 left-0 right-0 h-[2px]" style={{ background: 'linear-gradient(90deg, transparent, #c9a84c50, transparent)' }} />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 mb-4">
            <div className="w-8 h-[2px] bg-[#c9a84c]" />
            <span className="text-[#c9a84c] text-[11px] font-bold uppercase tracking-[0.28em]">Client Testimonials</span>
            <div className="w-8 h-[2px] bg-[#c9a84c]" />
          </div>
          <h2
            className="text-white font-bold leading-tight mb-4"
            style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(30px, 4vw, 52px)' }}
          >
            What Our Clients Say
          </h2>
          <div className="flex items-center justify-center gap-1 mt-3">
            {[1,2,3,4,5].map(i => (
              <div key={i} className="w-5 h-5 flex items-center justify-center">
                <i className="ri-star-fill text-[#c9a84c] text-base" />
              </div>
            ))}
            <span className="text-white/40 text-sm ml-2">5.0 Google Average · 50+ Reviews</span>
          </div>
        </div>

        {/* 3-card layout — desktop */}
        <div className="hidden lg:grid grid-cols-3 gap-5 mb-10">
          {[left, center, right].map((idx, pos) => {
            const t = allTestimonials[idx];
            const isFeatured = pos === 1;
            return (
              <div
                key={idx}
                onClick={() => setActive(idx)}
                className={`relative rounded-2xl cursor-pointer transition-all duration-400 overflow-hidden ${
                  isFeatured
                    ? 'bg-white scale-[1.03] shadow-2xl shadow-black/50'
                    : 'bg-white/6 border border-white/8 hover:border-white/15 opacity-65 hover:opacity-80 scale-100'
                }`}
              >
                {/* Gold top bar on featured */}
                {isFeatured && (
                  <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[#c9a84c] via-[#e8cc85] to-[#c9a84c]" />
                )}

                <div className="p-7">
                  {/* Stars */}
                  <div className="flex items-center gap-1 mb-4">
                    {Array.from({ length: t.stars }).map((_, i) => (
                      <div key={i} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-[#c9a84c] text-sm" />
                      </div>
                    ))}
                    <span className={`ml-2 text-xs font-bold uppercase tracking-wider px-2.5 py-1 rounded-full ${isFeatured ? 'text-[#c9a84c] bg-[#c9a84c]/10' : 'text-[#c9a84c]/80 bg-[#c9a84c]/10'}`}>
                      {t.type}
                    </span>
                  </div>

                  {/* Big quote */}
                  <div className={`text-6xl font-serif leading-none mb-3 opacity-15 select-none ${isFeatured ? 'text-[#050a12]' : 'text-white'}`}>&ldquo;</div>

                  <p className={`text-[15px] leading-[1.8] italic mb-6 ${isFeatured ? 'text-[#1a1a2e]' : 'text-white/60'}`}>
                    {t.text}
                  </p>

                  <div className="flex items-center justify-between pt-5" style={{ borderTop: isFeatured ? '1px solid #f0f0f0' : '1px solid rgba(255,255,255,0.08)' }}>
                    <div className="flex items-center gap-3">
                      <div className={`w-10 h-10 flex items-center justify-center rounded-full flex-shrink-0 ${isFeatured ? 'bg-[#050a12]' : 'bg-white/10'}`}>
                        <span className={`text-xs font-bold ${isFeatured ? 'text-[#c9a84c]' : 'text-white/70'}`}>{t.initials}</span>
                      </div>
                      <div>
                        <p className={`font-bold text-sm ${isFeatured ? 'text-[#0c1520]' : 'text-white/70'}`}>— {t.name}</p>
                        <p className={`text-xs ${isFeatured ? 'text-[#94a3b8]' : 'text-white/35'}`}>Verified Client</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <div className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-google-fill text-[#4285F4] text-sm" />
                      </div>
                      <span className={`text-xs ${isFeatured ? 'text-[#94a3b8]' : 'text-white/30'}`}>Google</span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Mobile — single card */}
        <div className="lg:hidden bg-white rounded-2xl p-7 mb-8 relative overflow-hidden">
          <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[#c9a84c] via-[#e8cc85] to-transparent" />
          <div className="flex items-center gap-1 mb-4">
            {Array.from({ length: allTestimonials[active].stars }).map((_, i) => (
              <div key={i} className="w-4 h-4 flex items-center justify-center">
                <i className="ri-star-fill text-[#c9a84c] text-sm" />
              </div>
            ))}
          </div>
          <p className="text-[#1a1a2e] text-base leading-[1.8] italic mb-6">&ldquo;{allTestimonials[active].text}&rdquo;</p>
          <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
            <div className="w-10 h-10 flex items-center justify-center bg-[#050a12] rounded-full flex-shrink-0">
              <span className="text-[#c9a84c] text-xs font-bold">{allTestimonials[active].initials}</span>
            </div>
            <div>
              <p className="text-[#0c1520] font-bold text-sm">— {allTestimonials[active].name}</p>
              <p className="text-[#94a3b8] text-xs">Verified Client</p>
            </div>
          </div>
        </div>

        {/* Navigation dots + arrows */}
        <div className="flex items-center justify-center gap-6">
          <button
            onClick={prev}
            className="w-11 h-11 flex items-center justify-center bg-white/7 border border-white/10 hover:bg-[#c9a84c] hover:border-[#c9a84c] rounded-full transition-all duration-200 cursor-pointer"
            aria-label="Previous"
          >
            <i className="ri-arrow-left-line text-white text-base" />
          </button>

          <div className="flex items-center gap-2">
            {allTestimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                className={`rounded-full transition-all duration-300 cursor-pointer ${i === active ? 'w-7 h-3 bg-[#c9a84c]' : 'w-3 h-3 bg-white/20 hover:bg-white/40'}`}
                aria-label={`Testimonial ${i + 1}`}
              />
            ))}
          </div>

          <button
            onClick={next}
            className="w-11 h-11 flex items-center justify-center bg-white/7 border border-white/10 hover:bg-[#c9a84c] hover:border-[#c9a84c] rounded-full transition-all duration-200 cursor-pointer"
            aria-label="Next"
          >
            <i className="ri-arrow-right-line text-white text-base" />
          </button>
        </div>
      </div>
    </section>
  );
}
